import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW4701Component } from './kymw4701.component';

import { GetMultiGoodsService } from './api-services/get-multi-goods.service';
import { GetCandidateGoodsService } from './api-services/get-candidate-goods.service';
import { GetMultiCodeInfoService } from './api-services/get-multi-code-info.service';
import { DeleteMultiGoodsService } from './api-services/delete-multi-goods.service';
import { RegistMultiGoodsService } from './api-services/regist-multi-goods.service';

/**
 * マルチ商品設定画面 モジュール設定クラス
 *
 * @export KYMW4701Module
 * @class KYMW4701Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
    FontAwesomeModule,
  ],
  declarations: [KYMW4701Component],
  providers: [
    GetMultiGoodsService,
    GetCandidateGoodsService,
    GetMultiCodeInfoService,
    RegistMultiGoodsService,
    DeleteMultiGoodsService,
  ],
})
export class KYMW4701Module {}
